import { ExpectedInbound, ExpectedInboundState } from '../api/models';

export const ExpectedInboundIncompleteStates = ['Created', 'InProgress'];

export function isExpectedInboundFinished(expectedInbound: ExpectedInbound) {
	return expectedInbound.state == ExpectedInboundState.Completed || expectedInbound.state == ExpectedInboundState.Canceled;
}
